/**
 * Should be used to render the design-tokens properly for each case (js or css)
 *
 * const tokens = require("./design-tokens/colors/brand");
 * const render = require("./design-tokens/render-design-tokens");
 * console.log(render(tokens))
 * // {... 'dell-alert-yellow': '#ffffc9' ...}
 * console.log(render(tokens, true))
 * //{...  'dell-alert-yellow': '#ffffc9 !default;' ...}
 *
 * @param {Object} object target object that will evaluated to a single depth object
 * @param {Boolean} renderCSS define if the token should be rendered as css or js
 * @returns {Object} new object
 */
export default function (object, renderCSS) {
    if (
        !object ||
        typeof object !== "object" ||
        Array.isArray(object) ||
        Object(object) !== object
    ) {
        return null;
    }
    return Object.keys(object).reduce((acc, key) => {
        let val = object[key];
        // When rencerCSS is defined and the value is the toCSS
        if (renderCSS && typeof val === "function") {
            val = val(true);
        }
        // When value is the toCSS function but we want the raw value
        else if (typeof val === "function") {
            val = val();
        }
        if (val === undefined) {
            throw new Error(`Unexpected token at ${key}:${val}; (typeof: ${typeof val})`);
        }
        acc[key] = val;
        return acc;
    }, {});
}
